<section class="justify-content z-index-71 w-100 position-fixed bg-header-white">
  <div class="it-quiz-div pt-4 pb-4 container container-mob d-flex align-items-center">
    <a href="/" class="cursor-pointer z-index-1">
      <img src="/assets/images/background/itquiz.png" alt="quiz" class="it-quiz cursor-pointer" href="/">
    </a>
    <div class="menu-div">
      <div class="p-0" [matMenuTriggerFor]="menu">
        <img src="/assets/images/responsive-landing/menu.png" alt="menu" class="menu-icon" *ngIf="!isMenuClicked" (click)="onMenuClick()">
        <img src="/assets/images/dot/close-menu.png" alt="close-menu" class="close-menu" *ngIf="isMenuClicked" (click)="onMenuClosed()">
      </div>
    </div>
    <div class="ps-lg-6 ps-3vw pb-1 gap-5 header-cards d-inline-block d-flex justify-content-between f-col">
      <a href="#for-every-need" class="text-decoration-none f-col"><h5 class="who-for fw-medium mb-0">Who&nbsp;it's&nbsp;for</h5></a>
      <a href="#fit-needs" class="text-decoration-none f-col"><h5 class="pricing fw-medium mb-0">Pricing</h5></a>
      <a href="/contact-us" class="text-decoration-none f-col"><h5 class="contact-us fw-medium mb-0">Contact&nbsp;Us</h5></a>
    </div>
    <div class="header-inner gap-2 d-flex justify-content-end container container-mob z-index-80">
      <div class="eng-div w-50px rounded-4 d-flex justify-content-center align-items-center">
        <h4 class="m-0 f-col fw-medium ls-02em lh-2 d-inline-block text-center cursor-pointer">Eng</h4>
      </div>
      <div class="h-40px">
        <a routerLink="/signin">
          <button type="submit" class="login-btn trial-style-p rounded-4 bg-white text-center h-40px ps-3 pe-3 d-flex justify-content-center align-items-center">
            <h4 class="f-col fw-medium pt-3">Login</h4>
          </button>
        </a>
      </div>
      <div>
        <a routerLink="/signup">
          <button type="submit" class="trial-style-p rounded-4 m-0 ls-02em bg-purple border-0 ps-3 pe-3 h-40px text-center d-flex justify-content-center align-items-center">
            <h4 class="f-col fw-medium lh-2 pt-3 mb-3">Start&nbsp;Free&nbsp;Trial</h4>
          </button>
        </a>
      </div>
    </div>
  </div>
  <mat-menu #menu="matMenu" (closed)="onMenuClosed()">
    <mat-divider></mat-divider>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-inline-block">
        <span class="product f-col fs-24px-lh-36px">Product</span>
      </div>
      <button mat-menu-item class="d-flex justify-content-end">
        <img src="/assets/images/arrow/arrow-outward.png" alt="arrow-outward" class="arrow-outward">
      </button>
    </div>
    <mat-divider></mat-divider>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-inline-block">
        <span class="who-for fs-24px-lh-36px f-col">Who&nbsp;it's&nbsp;for</span>
      </div>
      <a href="#for-every-need" class="text-decoration-none">
        <button mat-menu-item class="d-flex justify-content-end">
          <img src="/assets/images/arrow/arrow-outward.png" alt="arrow-outward" class="arrow-outward">
        </button>
      </a>
    </div>
    <mat-divider></mat-divider>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-inline-block">
        <span class="pricing fs-24px-lh-36px f-col">Pricing</span>
      </div>
      <a href="#fit-needs" class="text-decoration-none">
        <button mat-menu-item class="d-flex justify-content-end">
          <img src="/assets/images/arrow/arrow-outward.png" alt="arrow-outward" class="arrow-outward">
        </button>
      </a>
    </div>
    <mat-divider></mat-divider>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-inline-block">
        <span class="contact-us fs-24px-lh-36px">Contact&nbsp;Us</span>
      </div>
      <a href="/contact-us" class="text-decoration-none f-col">
        <button mat-menu-item class="d-flex justify-content-end">
          <img src="/assets/images/arrow/arrow-outward.png" alt="arrow-outward" class="arrow-outward">
        </button>
      </a>
    </div>
    <mat-divider></mat-divider>
    <div class="mt-15 d-flex justify-content-center">
      <button mat-menu-item class="trial-style-p rounded-4 ls-02em bg-purple btn-start-trial-menu border-0 d-flex justify-content-center">
        <a routerLink="/signup" class="text-decoration-none">
          <span class="f-col text-center fw-medium">Start&nbsp;Free&nbsp;Trial</span>
        </a>
      </button>
    </div>
    <div class="d-flex justify-content-center">
      <button class="login-btn bg-white h-40px rounded-4 ps-3 pe-3 login-div-menu justify-content-center d-flex align-items-center">
        <a routerLink="/signin" class="text-decoration-none">
          <span class="f-col text-center fw-medium">Login</span>
        </a>
      </button>
    </div>
    <div class="d-flex justify-content-center text-center mt-4 mt-25px mb-14">
      <div class="w-50px rounded-4">
        <h3 class="f-col fw-medium ls-02em"> &nbsp;Eng </h3>
      </div>
    </div>
  </mat-menu>
</section>
